import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { ConfigProvider } from "./contexts/ConfigContext";
import { PersistGate } from "redux-persist/integration/react";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import reportWebVitals from "./reportWebVitals";
import "./config/axios"; // attach token to requests, handle 401 → redirect to login
import "./index.scss";
import "bootstrap/dist/css/bootstrap.css";

import App from "./App";
import { store, persister } from "./store";

// Suppress the "Can't perform a React state update on an unmounted component"
// warning that originates from react-bootstrap Tabs internal animation timers.
// This is a known issue in react-bootstrap 2.x and does not affect functionality.
if (process.env.NODE_ENV !== "production") {
  const originalError = console.error.bind(console);
  console.error = (...args) => {
    if (
      typeof args[0] === "string" &&
      args[0].includes("Can't perform a React state update on an unmounted component")
    ) {
      return;
    }
    originalError(...args);
  };
}

ReactDOM.render(
  <Provider store={store}>
    <ConfigProvider>
      <PersistGate loading={null} persistor={persister}>
        <App />
      </PersistGate>
    </ConfigProvider>
  </Provider>,
  document.getElementById("root")
);
reportWebVitals();
// Service worker only registered in production builds — in dev the worker.js
// file doesn't exist which causes a MIME type error in the console.
if (process.env.NODE_ENV === "production") {
  serviceWorkerRegistration.register({
    onUpdate: (registration) => {
      const shouldRefresh = window.confirm(
        "A new version is available. Refresh now?"
      );
      if (!shouldRefresh) return;

      if (registration && registration.waiting) {
        registration.waiting.postMessage({ type: "SKIP_WAITING" });
        let reloaded = false;
        navigator.serviceWorker.addEventListener("controllerchange", () => {
          if (reloaded) return;
          reloaded = true;
          window.location.reload();
        });
      } else {
        window.location.reload();
      }
    },
  });
}
